export default __webpack_public_path__ + "static/media/subscription.eb107630.svg";